
import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ApiService } from 'src/app/shared/services/api.service';
import { IndustryTypeService } from 'src/app/shared/services/industry-type-services/industry-type.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-machine-registration-form',
  templateUrl: './machine-registration-form.component.html',
  styleUrls: ['./machine-registration-form.component.css']

})
export class MachineRegistrationFormComponent implements OnInit {
  machineType: any;
  errorMessage1: any
  equipmentToolsForm!: FormGroup;
  mform!: FormGroup;
  submitted = false;
  imageurl: any;
  file: any;
  statusOptions = [
    { id: 1, name: 'Available' },
    { id: 0, name: 'Unavailable' },
  ];
  machineCategories = [
    { id: 1, name: "Earthmoving Equipment" },
    { id: 2, name: "Lifting Equipment" },
    { id: 3, name: "Material Handling Equipment" },
    { id: 4, name: "Concrete Equipment" },
    { id: 5, name: "Road Construction Equipment" },
    { id: 6, name: "Compaction Equipment" },
    { id: 7, name: "Drilling and Foundation Equipment" },
    { id: 8, name: "Tunneling and Trenching Equipment" },
    { id: 9, name: "Demolition Equipment" },
    { id: 10, name: "Power Generation & Tools" },
    { id: 11, name: "Surveying & Measurement Tools" },
    { id: 12, name: "Finishing Equipment" }
  ];

  machineForm: FormGroup;
  machineTypes = ['HDD', 'JCB', 'Splicing', 'Blowing', 'Tracker'];
  consumables = ['Oil', 'Diesel', 'Grease'];

  currentDate = new Date();

  cValue = formatDate(this.currentDate, 'yyyy-MM-dd', 'en-US');
  projectList: any;
  constructor(
    private formBuilder: FormBuilder,

    private router: Router,
    private readonly toastrMsgService: ToastrMsgService,
    private apiService: ApiService,

  ) { }

  ngOnInit() {
    // this.mform = this.formBuilder.group({
    //     startDate: [new Date().toISOString().substring(0, 10), Validators.required],
    //     endDate: [new Date().toISOString().substring(0, 10), Validators.required],
    //     machineType: ['', Validators.required],
    //     machineName: ['', Validators.required],
    //     machineBrand: ['', Validators.required],
    //     machineModel: ['', Validators.required],
    //     serialNumber: ['', Validators.required],
    //     selectProject: ['', Validators.required],
    //     status: ['', Validators.required],
    //     purchaseDate: [new Date().toISOString().substring(0, 10), Validators.required],
    //   });

    this.mform = this.formBuilder.group({
      equipment_code: ['', Validators.required],
      equipment_name: ['', Validators.required],
      category: ['', Validators.required],
      capacity: ['', Validators.required],
      specification: ['', Validators.required],
      isActive: ['', Validators.required],
    });
    //in project
    /* this.mform = this.formBuilder.group({
       startDate: [new Date().toISOString().substring(0, 10), Validators.required],
       endDate: [new Date().toISOString().substring(0, 10), Validators.required],
       machineType: ['', Validators.required],
       machineName: ['', Validators.required],
       machineBrand: ['', Validators.required],
       machineModel: ['', Validators.required],
       serialNumber: ['', Validators.required],
       selectProject: ['', Validators.required],
       status: ['', Validators.required],
       purchaseDate: [new Date().toISOString().substring(0, 10), Validators.required]
     });
     */

    this.equipmentToolsForm = this.formBuilder.group({
      heavyEquipment: this.formBuilder.group({
        type: ['', Validators.required],
        makeModel: ['', Validators.required],
        capacity: ['', Validators.required],
        ownership: ['', Validators.required],
        maintenanceSchedule: ['', Validators.required]
      }),
      testingEquipment: this.formBuilder.group({
        type: ['', Validators.required],
        calibrationStatus: ['', Validators.required],
        labCertification: ['', Validators.required]
      }),
      toolsInventory: this.formBuilder.group({
        typeQuantity: ['', Validators.required],
        condition: ['', Validators.required],
        replacementSchedule: ['', Validators.required]
      })
    });

    this.machineForm = this.formBuilder.group({
      machineType: ['', Validators.required],
      make: ['', Validators.required],
      capacity: [null, [Validators.required, Validators.min(0.1)]],
      modelMonthYear: ['', Validators.required],
      modelNumber: ['', [Validators.required, Validators.maxLength(10)]],
      commissioningDate: [''],
      registrationNumber: [''],
      serialNumber: [''],
      ownerRefNumber: [''],
      yieldTable: [''],
      consumables: [[]],
      minorMaintenance: [null, Validators.min(0)],
      majorMaintenance: [null, Validators.min(0)],
      image: [null],
      owner: [''],
      ownershipSince: [''],
    });
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.machineForm.patchValue({ image: file });
    }
  }

  onSubmitM() {
    if (this.machineForm.valid) {
      console.log(this.machineForm.value);
    } else {
      this.machineForm.markAllAsTouched();
    }
  }
  get f(): { [key: string]: AbstractControl } {
    return this.mform.controls;
  }


  onSubmit(): void {
    console.log(this.mform.value)
    // if (this.orgForm.invalid) {
    //   this.orgForm.markAllAsTouched();
    //   return;
    // }

    console.log("err", this.mform.value);
    this.apiService.saveMachine(this.mform.value).subscribe({
      next: (res) => {
        console.log(res);
        // this.router.navigate(['home/dashboard'])
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  onReset(): void {
    this.submitted = false;
    this.mform.reset();
  }
  handleFileInput(event: any) {
    this.file = event.target.files[0];
    const fileSize = this.file.size / 1024 / 1024; // Convert bytes to KB
    const fileType = this.file.type;

    if (!this.file) {
      // this.errorMessage1 = 'No file chosen.';
      return;
    }

    if (fileType !== 'image/jpeg' && fileType !== 'image/png') {
      this.errorMessage1 = 'File should be JPEG or PNG.';
      return;
    }

    if (fileSize > 3) {
      this.errorMessage1 = 'File size should be less than 3 MB.';
      return;
    }

    this.imageurl = URL.createObjectURL(this.file);

  }
}

